import Translate from '../Translate/Translate';
import styled from 'styled-components';
import Typography from 'carbon-react/lib/components/typography';

import MaintenanceModeImage from '../../assets/img/maintenance-mode.svg';

const Root = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space[3]};
  padding: ${({ theme }) => theme.space[5]};
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.palette.black};
  text-align: center;
`;

const Image = styled.img`
  max-width: 530px;
  width: 100%;
`;

const MaintenanceModeComponent = ({ time }: { time: string }) => {
  return (
    <Root>
      <Typography variant="h1">
        <Translate scope="maintenanceModeTitle" />
      </Typography>
      <Typography variant="p">
        <Translate scope="maintenanceModeSubtitle" />
        <strong>{time}</strong>
        <span>.</span>
      </Typography>
      <Image alt="maintenance mode" src={MaintenanceModeImage} />
    </Root>
  );
};

export default MaintenanceModeComponent;
